/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoSendInvitationInput = {
    clientMutationId?: string | null;
    slug: string;
};
export type ContactShowHeroTabBarSendInviteMutationVariables = {
    input: infoSendInvitationInput;
};
export type ContactShowHeroTabBarSendInviteMutationResponse = {
    readonly infoSendInvitation: {
        readonly contact: {
            readonly slug: string;
        };
    } | null;
};
export type ContactShowHeroTabBarSendInviteMutation = {
    readonly response: ContactShowHeroTabBarSendInviteMutationResponse;
    readonly variables: ContactShowHeroTabBarSendInviteMutationVariables;
};



/*
mutation ContactShowHeroTabBarSendInviteMutation(
  $input: infoSendInvitationInput!
) {
  infoSendInvitation(input: $input) {
    contact {
      slug
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ContactShowHeroTabBarSendInviteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "infoSendInvitationPayload",
        "kind": "LinkedField",
        "name": "infoSendInvitation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Contact",
            "kind": "LinkedField",
            "name": "contact",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContactShowHeroTabBarSendInviteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "infoSendInvitationPayload",
        "kind": "LinkedField",
        "name": "infoSendInvitation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Contact",
            "kind": "LinkedField",
            "name": "contact",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0078aa23f75e6df3626b23c985a96e5b",
    "id": null,
    "metadata": {},
    "name": "ContactShowHeroTabBarSendInviteMutation",
    "operationKind": "mutation",
    "text": "mutation ContactShowHeroTabBarSendInviteMutation(\n  $input: infoSendInvitationInput!\n) {\n  infoSendInvitation(input: $input) {\n    contact {\n      slug\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '0eaffdf891f80a163ae08d9b3cd5dd2e';
export default node;
